'use client'

import Footer from '@/components/landing-page/footer'

import {
  Box,
  Text,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from '@chakra-ui/react'
import { Search } from 'lucide-react'
import { faqs } from './faqs'
import { SetStateAction, useEffect, useState } from 'react'
import { AddIcon, MinusIcon } from '@chakra-ui/icons'
import Analytics from '../../analytics'

export default function Home() {
  const [search, setSearch] = useState('')
  const [queryQuestion, setQueryQuestion] = useState('')
  const handleChange = (event: {
    target: { value: SetStateAction<string> }
  }) => {
    setSearch(event.target.value)
  }
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const searchParams = new URLSearchParams(window.location.search)
      setQueryQuestion(searchParams?.get('query') || '')
    }
  }, [])
  useEffect(() => {
    if (queryQuestion) {
      setSearch(queryQuestion)
    } else {
      setSearch('')
    }
  }, [queryQuestion])

  return (
    <>
      <div className="bg-white">
        {/* <Analytics eventType="faq" /> */}
        <Box
          margin={'auto'}
          maxW={'92%'}
          position={'relative'}
          className="w-full"
        >
          <br />
          <Text fontSize={22} fontWeight={600} color={'lyk-green'}>
            FAQs
          </Text>
          <Text fontSize={45} fontWeight={600}>
            Frequently Asked Questions
          </Text>
          <Text fontSize={18} fontWeight={500} opacity={0.5}>
            Have questions about earning and LYKSTAGE? We’re here to help.
          </Text>

          <br />
          <br />

          <InputGroup w={['100%', '100%', '70%']}>
            <Input
              value={search}
              onChange={handleChange}
              placeholder="Search questions"
              borderColor="#D3D3D3"
            />
            <InputRightElement>
              <Icon as={Search} />
            </InputRightElement>
          </InputGroup>

          <br />
          <br />

          <Accordion
            display={'flex'}
            flexDir={'column'}
            gap={5}
            allowToggle
            variant={'unstyled'}
            key={search === queryQuestion ? '1' : '2'}
            defaultIndex={
              queryQuestion && search === queryQuestion ? 0 : undefined
            }
          >
            {faqs
              .filter((item: { question: string; answer: any }) => {
                return (
                  item.question.toLowerCase().includes(search.toLowerCase()) ||
                  JSON.stringify(item.answer)
                    .toLowerCase()
                    .includes(search.toLowerCase())
                )
              })
              .map((e: { question: string; answer: any }, index: number) => {
                return (
                  <AccordionItem
                    borderColor={'#D3D3D350'}
                    borderWidth={1}
                    rounded={'xl'}
                    overflow={'hidden'}
                    key={index}
                  >
                    {({ isExpanded }) => (
                      <>
                        <h2>
                          <AccordionButton
                            display={'flex'}
                            justifyContent={'space-between'}
                            background={isExpanded ? 'lyk-green' : '#ECECEC'}
                            color={isExpanded ? 'white' : 'black'}
                            px={10}
                            py={5}
                            roundedBottomLeft={isExpanded ? 0 : 'xl'}
                            roundedBottomRight={isExpanded ? 0 : 'xl'}
                            _hover={{ opacity: 0.7 }}
                          >
                            <Text
                              textAlign={'left'}
                              fontSize={[18, 18, 20]}
                              fontWeight={500}
                            >
                              {e.question}
                            </Text>
                            {isExpanded ? (
                              <MinusIcon fontSize="12px" />
                            ) : (
                              <AddIcon fontSize="12px" />
                            )}
                          </AccordionButton>
                        </h2>

                        <AccordionPanel p={4}>
                          <Text color={'#3E3E3E'} fontSize={17} opacity={0.7}>
                            {e.answer}
                          </Text>
                        </AccordionPanel>
                      </>
                    )}
                  </AccordionItem>
                )
              })}
          </Accordion>

          <br />
          <br />
        </Box>

        <section>
          <Footer />
        </section>
      </div>
    </>
  )
}
